<template>
  <input
    type="color"
    :value="editor.getAttributes('textStyle').color"
    @input="editor.chain().focus().setColor($event.target.value).run()"
  />
</template>

<script>
export default {
  components: {},
  props: {
    editor: { type: Object, default: () => {} },
  },
  emits: [],
  setup() {
    return {};
  },
};
</script>